import { useMediaQuery } from '@/hooks'

import { VIEW_SETTINGS_INLINE_MIN_WIDTH } from './linked-columns.constants'

const INLINE_QUERY = `(min-width: ${VIEW_SETTINGS_INLINE_MIN_WIDTH}px)`

// Note: true when the screen is wide enough for the view settings island beside the columns;
// below that they live in a menu in the page header
export const useViewSettingsInline = () => useMediaQuery(INLINE_QUERY)
